const pricingConstants = {
  FETCH_PRICING_SUCCESS: 'PRICINIG_FETCH_SUCCESS',
  FETCH_PRICING_FAILURE: 'PRICING_FETCH_FAILURE'
};

export { pricingConstants };
